import React, { useState, useEffect } from 'react';

// Function to generate random status data
const generateStatusData = () => {
  const statuses = [
    { status: 'Operational', statusClass: 'status-excellent', details: 'Running smoothly' },
    { status: 'Good', statusClass: 'status-good', details: 'Functioning normally' },
    { status: 'Needs Maintenance', statusClass: 'status-warning', details: 'Reduced efficiency detected' },
    { status: 'Replace', statusClass: 'status-critical', details: 'Clogged, requires immediate replacement' },
  ];
  return statuses[Math.floor(Math.random() * statuses.length)];
};

// Function to get current timestamp
const getCurrentTimestamp = () => {
  const now = new Date();
  return now.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

function SystemStatus() {
  const [components, setComponents] = useState([
    { name: 'RO Pump', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
    { name: 'Membrane', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
    { name: 'Feed Pump', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
    { name: 'Filter PPC', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
    { name: 'Flow Meter', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
  ]);
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Update data every 10 minutes
    const intervalId = setInterval(() => {
      setComponents([
        { name: 'RO Pump', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
        { name: 'Membrane', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
        { name: 'Feed Pump', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
        { name: 'Filter PPC', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
        { name: 'Flow Meter', ...generateStatusData(), lastChecked: getCurrentTimestamp() },
      ]);
    }, 600000); // 10 minutes in milliseconds

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // Inline styles for cards
  const cardStyle = {
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    marginBottom: '15px',
    borderLeft: '4px solid #06b6d4'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  };

  const nameStyle = {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#1f2937'
  };

  const statusStyle = {
    padding: '5px 10px',
    borderRadius: '15px',
    fontSize: '0.9rem',
    fontWeight: '600'
  };

  const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  };

  const detailStyle = {
    fontSize: '0.9rem',
    color: '#6b7280',
    marginTop: '5px'
  };

  const timestampStyle = {
    fontSize: '0.85rem',
    color: '#9ca3af',
    fontStyle: 'italic'
  };

  // Render table for desktop
  const renderTable = () => (
    <div style={{ overflowX: 'auto' }}>
      <table className="status-table">
        <thead>
          <tr>
            <th>Component</th>
            <th>Status</th>
            <th>Last Checked</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {components.map((comp, index) => (
            <tr key={index}>
              <td>{comp.name}</td>
              <td><span className={`stat-status ${comp.statusClass}`} style={statusStyle}>{comp.status}</span></td>
              <td>{comp.lastChecked}</td>
              <td>{comp.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // Render cards for mobile
  const renderCards = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
      {components.map((comp, index) => (
        <div key={index} style={cardStyle}>
          <div style={headerStyle}>
            <h3 style={nameStyle}>{comp.name}</h3>
            <span className={`stat-status ${comp.statusClass}`} style={statusStyle}>{comp.status}</span>
          </div>
          <div style={bodyStyle}>
            <p style={detailStyle}>{comp.details}</p>
            <p style={timestampStyle}>Last Checked: {comp.lastChecked}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="content-card">
      <h2>
        <i className="fas fa-cogs"></i> System Component Status
      </h2>
      {isMobile ? renderCards() : renderTable()}
    </div>
  );
}

export default SystemStatus;